<div class="grid-body">
  <tabset #staticTabs>
    <tab [heading]="'filter' | translate" (select)="filterTabSelected()">
      <div>
        <div class="custom-filter-wrapper">
          <div
            class="col-md-12 col-sm-12 d-flex p-1 report-alert"
            *ngIf="alertShow"
          >
            <kl-alert
              [message]="alertMessage"
              type="error"
              [show]="alertShow"
              (onClose)="alertShow = false"
            ></kl-alert>
          </div>
          <div class="custom-filter-inner col-md-12 col-sm-12">
            <div class="filter-options col-md-6 col-sm-6 p-0 m-0">
              <div class="search-filter-form">
                <div class="search-filter-form-content m-0">
                  <form #filterForm="ngForm">
                    <div class="filter-group" #materialStatus>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialStatus.collapsed = !materialStatus.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_status" | translate }}
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialStatus.collapsed,
                              'fa-angle-down': !materialStatus.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialStatus.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          #materialStatusDropdown
                          [options]="materialStatusOptions"
                          name="material_status"
                          [(ngModel)]="materialStatusValue"
                          [style]="{ width: '90%' }"
                        >
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="filter-group" #materialType>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialType.collapsed = !materialType.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_type" | translate }}
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialType.collapsed,
                              'fa-angle-down': !materialType.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialType.collapsed"
                      >
                        <p-listbox
                          [multiple]="true"
                          checkbox="checkbox"
                          #materialStatusListbox
                          [options]="materialTypeOptions"
                          name="material_type"
                          [(ngModel)]="materialTypeValue"
                          [style]="{ width: '90%' }"
                        ></p-listbox>
                      </div>
                    </div>
                    <div class="filter-group" #materialCode>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialCode.collapsed = !materialCode.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_code" | translate }}
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialCode.collapsed,
                              'fa-angle-down': !materialCode.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialCode.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          name="material_code"
                          #materialCodeDropdown
                          [(ngModel)]="materialCodeExpressionValue"
                          [options]="materialExpressionOptions"
                          autoWidth="false"
                          [style]="{ width: '90%' }"
                        ></p-dropdown>
                        <div class="form-group my-1">
                          <input
                            type="text"
                            [(ngModel)]="materialCodeValue"
                            #materialCodeInput
                            name="material_code_input"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="filter-group" #materialDescription>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialDescription.collapsed =
                            !materialDescription.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_description" | translate }}
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialDescription.collapsed,
                              'fa-angle-down': !materialDescription.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialDescription.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          name="material_description"
                          #materialDescriptionDropdown
                          [(ngModel)]="materialDescriptionExpressionValue"
                          [options]="materialExpressionOptions"
                          autoWidth="false"
                          [style]="{ width: '90%' }"
                        ></p-dropdown>
                        <div class="form-group my-1">
                          <input
                            type="text"
                            [(ngModel)]="materialDescriptionValue"
                            #materialDescriptionInput
                            name="material_description_input"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="filter-group" #materialSpecode1>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialSpecode1.collapsed =
                            !materialSpecode1.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_special_code" | translate }}
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialSpecode1.collapsed,
                              'fa-angle-down': !materialSpecode1.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialSpecode1.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          name="material_specode1"
                          #materialSpecodeDropdown
                          [(ngModel)]="materialSpecodeExpressionValue1"
                          [options]="materialExpressionOptions"
                          autoWidth="false"
                          [style]="{ width: '90%' }"
                        ></p-dropdown>
                        <div class="form-group my-1">
                          <div class="input-group" style="width: 90%">
                            <input
                              type="text"
                              [(ngModel)]="materialSpeCodeValue1"
                              #materialSpecodeInput
                              name="material_specode_1_input"
                              class="form-control form-control-sm"
                              maxlength="20"
                            />
                            <div class="input-group-append">
                              <span
                                class="input-group-text transparent"
                                (click)="
                                  setModal(
                                    'specode',
                                    'SPECODE1',
                                    MaterialSpecodeListComponent
                                  )
                                "
                              >
                                <i class="fal fa-ellipsis-h"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="filter-group" #materialSpecode2>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialSpecode2.collapsed =
                            !materialSpecode2.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_special_code" | translate }} 2
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialSpecode2.collapsed,
                              'fa-angle-down': !materialSpecode2.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialSpecode2.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          name="material_specode_2"
                          #materialSpecodeDropdown2
                          [(ngModel)]="materialSpecodeExpressionValue2"
                          [options]="materialExpressionOptions"
                          autoWidth="false"
                          [style]="{ width: '90%' }"
                        ></p-dropdown>
                        <div class="form-group my-1">
                          <div class="input-group" style="width: 90%">
                            <input
                              type="text"
                              [(ngModel)]="materialSpeCodeValue2"
                              #materialSpecodeInput
                              name="material_specode_2_input"
                              class="form-control form-control-sm"
                              maxlength="20"
                            />
                            <div class="input-group-append">
                              <span
                                class="input-group-text transparent"
                                (click)="
                                  setModal(
                                    'specode',
                                    'SPECODE2',
                                    MaterialSpecodeListComponent
                                  )
                                "
                              >
                                <i class="fal fa-ellipsis-h"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="filter-group" #materialSpecode3>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialSpecode3.collapsed =
                            !materialSpecode3.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_special_code" | translate }} 3
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialSpecode3.collapsed,
                              'fa-angle-down': !materialSpecode3.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialSpecode3.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          name="material_specode_3"
                          #materialSpecodeDropdown3
                          [(ngModel)]="materialSpecodeExpressionValue3"
                          [options]="materialExpressionOptions"
                          autoWidth="false"
                          [style]="{ width: '90%' }"
                        ></p-dropdown>
                        <div class="form-group my-1">
                          <div class="input-group" style="width: 90%">
                            <input
                              type="text"
                              [(ngModel)]="materialSpeCodeValue3"
                              #materialSpecodeInput
                              name="material_specode_3_input"
                              class="form-control form-control-sm"
                              maxlength="20"
                            />
                            <div class="input-group-append">
                              <span
                                class="input-group-text transparent"
                                (click)="
                                  setModal(
                                    'specode',
                                    'SPECODE3',
                                    MaterialSpecodeListComponent
                                  )
                                "
                              >
                                <i class="fal fa-ellipsis-h"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="filter-group" #materialSpecode4>
                      <div
                        class="filter-group-heading ui-clickable"
                        (click)="
                          materialSpecode4.collapsed =
                            !materialSpecode4.collapsed
                        "
                      >
                        <p class="font-weight-light">
                          {{ "material_special_code" | translate }} 4
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-angle-up': materialSpecode4.collapsed,
                              'fa-angle-down': !materialSpecode4.collapsed
                            }"
                          ></i>
                        </p>
                      </div>
                      <div
                        class="filter-group-content"
                        [collapse]="!materialSpecode4.collapsed"
                      >
                        <p-dropdown
                          [emptyFilterMessage]="'not_found' | translate"
                          name="material_specode_4"
                          #materialSpecodeDropdown4
                          [(ngModel)]="materialSpecodeExpressionValue4"
                          [options]="materialExpressionOptions"
                          autoWidth="false"
                          [style]="{ width: '90%' }"
                        ></p-dropdown>
                        <div class="form-group my-1">
                          <div class="input-group" style="width: 90%">
                            <input
                              type="text"
                              [(ngModel)]="materialSpeCodeValue4"
                              #materialSpecodeInput
                              name="material_specode_4_input"
                              class="form-control form-control-sm"
                              maxlength="20"
                            />
                            <div class="input-group-append">
                              <span
                                class="input-group-text transparent"
                                (click)="
                                  setModal(
                                    'specode',
                                    'SPECODE4',
                                    MaterialSpecodeListComponent
                                  )
                                "
                              >
                                <i class="fal fa-ellipsis-h"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="filter-values col-md-6 col-sm-6 p-0 m-0">
              <div class="filter-values-content col-md-12 col-sm-12 p-0">
                <ul
                  class="filter-list col-md-12 col-sm-12"
                  style="max-height: 65vh"
                >
                  <li
                    class="col-md-12 col-sm-12"
                    *ngFor="let item of selectedFilterValues; let i = index"
                  >
                    <div class="values">
                      <span class="key">{{ item.label | translate }} : </span>
                      <span class="value" *ngIf="isArray(item.value)">
                        <span *ngFor="let val of item.value; let i = index">
                          <i *ngIf="i > 0">, </i>
                          {{ get(val, item.accessor) | translate }}
                        </span>
                      </span>
                      <span class="value" *ngIf="!isArray(item.value)">
                        <span *ngIf="isDate(item.value)">
                          {{ convertDate(item.value) }}
                        </span>
                        <span *ngIf="!isDate(item.value)">
                          <span *ngIf="item.accessor">
                            {{ get(item.value, item.accessor) | translate }}
                          </span>
                          <span *ngIf="!item.accessor">
                            {{ item.value | translate }}
                          </span>
                        </span>
                      </span>
                    </div>
                    <div
                      class="tooltip-overlay"
                      [tooltip]="getTranslated(item.value, item.accessor)"
                      container="body"
                    ></div>
                    <a
                      role="button"
                      class="close"
                      (click)="deleteFromValues(i, item)"
                    >
                      <i class="fal fa-trash"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab
      [heading]="'material' | translate"
      [disabled]="materialList.length < 1"
      (select)="materialListTabSelected()"
    >
      <div>
        <wj-flex-grid
          #bulkMaterialImportGrid
          [deferResizing]="true"
          [itemsSource]="materialCollectionView"
          [isReadOnly]="materialList.length === 0"
          [allowDelete]="false"
          [allowSorting]="false"
          [allowDragging]="'None'"
          style="max-height: 430px"
          [headersVisibility]="'Column'"
        >
          <wj-flex-grid-column
            [allowSorting]="false"
            [isReadOnly]="true"
            [header]="'select' | translate"
            [binding]="'selected'"
            [width]="40"
          >
            <ng-template
              wjFlexGridCellTemplate
              [cellType]="'ColumnHeader'"
              let-item="item"
              let-cell="cell"
            >
              <p-checkbox
                name="grid_checkbox_all"
                [(ngModel)]="allChecked"
                (onChange)="changeAllCheck($event)"
                binary="true"
                styleClass="kl-checkbox"
              ></p-checkbox>
            </ng-template>
            <ng-template
              wjFlexGridCellTemplate
              [cellType]="'Cell'"
              let-cell="cell"
            >
              <p-checkbox
                name="grid_checkbox"
                binary="true"
                [(ngModel)]="cell.item['selected']"
                (onChange)="changeCheckBox($event, cell)"
                styleClass="kl-checkbox"
              ></p-checkbox>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column
            [header]="'code' | translate"
            [isReadOnly]="true"
            [binding]="'material.code'"
            [width]="'*'"
          ></wj-flex-grid-column>
          <wj-flex-grid-column
            [header]="'description' | translate"
            [isReadOnly]="true"
            [binding]="'material.description'"
            [width]="'*'"
          ></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </tab>
  </tabset>
</div>
<div class="col-md-12 col-sm-12 bulk-material footer">
  <div class="col-md-6 col-sm-12 d-grid">
    <span class="label" *ngIf="materialTabSelect"
      >{{ "total_data_length" | translate }} :
      <span>{{ totalDataLength }}</span></span
    >
    <span class="label" *ngIf="materialTabSelect"
      >{{ "selected_data_length" | translate }} :
      <span>{{ selectedDataLength }}</span></span
    >
  </div>
  <div class="modal-footer col-md-6 col-sm-12">
    <button
      class="btn btn-sm btn-greenish"
      *ngIf="filterTabSelect"
      (click)="commitFilter()"
    >
      {{ "apply" | translate }}
    </button>
    <button
      class="btn btn-sm btn-greenish"
      *ngIf="materialTabSelect"
      [disabled]="materialList.length < 1"
      (click)="importSelectedMaterials()"
    >
      {{ "import_materials" | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="closeModal()">
      {{ "cancel" | translate }}
    </button>
  </div>
</div>
